/**
 * Focus the chat composer textarea (`[data-tour="chat-input"]`).
 *
 * Used after sidebar "Chat" navigation: the composer may not be mounted yet
 * when leaving another route, so we retry briefly across animation frames.
 */
export function focusChatComposer() {
  const tryFocus = (attemptsLeft: number) => {
    const el = document.querySelector<HTMLTextAreaElement>(
      '[data-tour="chat-input"]',
    );
    if (el && !el.disabled) {
      el.focus();
      return;
    }
    if (attemptsLeft > 0) {
      requestAnimationFrame(() => tryFocus(attemptsLeft - 1));
    }
  };
  requestAnimationFrame(() => tryFocus(40));
}
